// extracted by mini-css-extract-plugin
export default {"paymentsWrapper":"Payments_paymentsWrapper__dO-zc","storeCard":"Payments_storeCard__Aaf37","storeTitle":"Payments_storeTitle__wQzCa"};